@if ({
  distances: distances$ | async,
  units: units$ | async,
  products: products$ | async,
  types: types$ | async,
  }; as content) {
  <div class="simple-card m-t-20">
    <form [formGroup]="form" (submit)="submit()">
      <div class="row">
        <div class="col-12 col-lg-2">
          <div class="form-group">
            <countries-dropdown
              [hideDialingCode]="true"
              [isocode]="country?.isocode"
              [countries$]="countries$"
              (_onSelectCountry)="setCountry($event)"
              [form]="form"
            ></countries-dropdown>
            <cx-form-errors [control]="form.get('country')?.get('isocode')!"></cx-form-errors>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label>
              <span class="label-content">{{ 'storeFinder.searchBoxLabel' | cxTranslate }}</span>
              <input class="form-control" type="text" name="search" maxlength="255" placeholder="..." formControlName="search" />
              <cx-form-errors [control]="form.get('search')"></cx-form-errors>
            </label>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label>
              <span class="label-content">{{ 'storeFinder.product' | cxTranslate }}</span>
              <select class="form-control" formControlName="product">
                <option value="" disabled selected>{{ 'generic.selectAnOption' | cxTranslate }}</option>
                @for (item of content.products; track item) {
                  <option [attr.aria-label]="item.label" value="{{ item.code }}">
                    {{ item.label }}
                  </option>
                }
              </select>
              <cx-form-errors [control]="form.get('product')"></cx-form-errors>
            </label>
          </div>
        </div>
        @if ((content.distances || []).length > 1) {
          <div class="col-12 col-lg-4">
            <div class="form-group">
              <label for="">
                <span class="label-content">{{ 'storeFinder.distance' | cxTranslate }}</span>
                <div class="content-radio">
                  @for (type of content.distances; track type) {
                    <div class="form-check">
                      <input
                        id="radio-{{ type.code }}"
                        class="form-check-input"
                        role="radio"
                        type="radio"
                        aria-checked="true"
                        [value]="type.code"
                        formControlName="distance"
                        />
                        <label class="form-check-label form-radio-label" for="radio-{{ type.code }}">
                          {{ type.label }}
                        </label>
                      </div>
                    }
                  </div>
                  <cx-form-errors [control]="form.get('distance')"></cx-form-errors>
                </label>
              </div>
            </div>
          }
          @if ((content.units || []).length > 1) {
            <div class="col-12 col-lg-2">
              <div class="form-group">
                <label for="">
                  <span class="label-content">{{ 'storeFinder.unit' | cxTranslate }}</span>
                  <div class="content-radio">
                    @for (type of content.units; track type) {
                      <div class="form-check">
                        <input
                          id="radio-{{ type.code }}"
                          class="form-check-input"
                          role="radio"
                          type="radio"
                          aria-checked="true"
                          [value]="type.code"
                          formControlName="unit"
                          />
                          <label class="form-check-label form-radio-label" for="radio-{{ type.code }}">
                            {{ type.label }}
                          </label>
                        </div>
                      }
                    </div>
                    <cx-form-errors [control]="form.get('unit')"></cx-form-errors>
                  </label>
                </div>
              </div>
            }
            @if ((content.types || []).length > 1) {
              <div class="col-12 col-lg-6">
                <div class="container-checks">
                  <div class="form-group">
                    <label for="">
                      <span>{{ 'storeFinder.whereToBuy' | cxTranslate }}</span>
                    </label>
                    <div class="container-checks">
                      @for (type of content.types; track type) {
                        <div class="form-check">
                          <label>
                            <input #input type="checkbox" formControlName="{{ type.code }}" (click)="handlerClickType(input, type)" />
                            <span class="form-check-label"> {{ type.label }} </span>
                            <cx-form-errors [control]="form.get(type.code)"></cx-form-errors>
                          </label>
                        </div>
                      }
                    </div>
                    <cx-form-errors [control]="form.get('whereToBuy')"></cx-form-errors>
                  </div>
                </div>
              </div>
            }
            <div class="col-12">
              <div class="search-actions">
                <button type="button" class="btn btn-outline-primary btn-sm" (click)="resetForm()">
                  <span class="material-symbols-outlined d-flex m-r-4"> delete </span>
                  {{ 'storeFinder.clear' | cxTranslate }}
                </button>
                <button class="btn btn-primary btn-sm">
                  <span class="material-symbols-outlined d-flex m-r-4"> search </span>
                  {{ 'storeFinder.search' | cxTranslate }}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    }
